export const TextProps = (formik: any, name: string) => ({
  value: formik.values[name],
  onChange: formik.handleChange,
  onBlur: formik.handleBlur,
  error:
    formik.submitCount && formik.touched[name]
      ? formik.errors[name]
      : undefined,
})
